module.exports = __webpack_public_path__ + "img/dp_lp_pc_copy.e1679c10.png";